import React from "react";
import { Link } from "react-router-dom";
import AssetWrapper from "./AssetWrapper";
import AssetName from "./AssetName";

class LinkToAssetById extends React.Component {
  render() {
    const symbol = this.props.asset.get("symbol");
    const assetName = /*#__PURE__*/React.createElement(AssetName, {
      name: symbol,
      noTip: true
    });
    return this.props.noLink ? assetName : /*#__PURE__*/React.createElement(Link, {
      to: `/asset/${symbol}/`
    }, assetName);
  }

}

export default AssetWrapper(LinkToAssetById);